import { render } from "./PartnerReport.vue?vue&type=template&id=61ca3ace&scoped=true"
import script from "./PartnerReport.vue?vue&type=script&lang=js"
export * from "./PartnerReport.vue?vue&type=script&lang=js"

import "./PartnerReport.vue?vue&type=style&index=0&id=61ca3ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ca3ace"]])

export default __exports__